import { IComparisonConversion } from '@nkr/models/index';

export interface IComparisonConversionWithSelect extends IComparisonConversion {
    selected: boolean
}